<template>
  <div>
    <div v-if="isLoading" style="position: absolute;left:40%;top:30%;z-index: 99;">
      <v-btn :loading="true" text x-large fab></v-btn>
      <div class="pl-1">Loading...</div>
    </div>
    <div id="rateBarGraph"></div>
  </div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { mapState } from 'vuex';

am4core.useTheme(am4themes_animated);

export default {
  name: 'chatBarGraph',

  data () {
    return {
      isLoading: true
    };
  },

  props: {
    barData: {
      required: true,
      type: Array
    },
    sortByKey: {
      required: true,
      type: String
    }
  },

  watch: {
    barData: {
      deep: true,
      immediate: true,
      handler () {
        this.isLoading = true;
        am4core.disposeAllCharts();
        this.createChart();
      }
    }
  },

  computed: {
    ...mapState({
      updateEmployeeFilters: state => state.updateEmployeeFilters
    })
  },

  beforeDestroy () {
    am4core.disposeAllCharts();
  },

  methods: {
    createChart () {
      var chart = am4core.create('rateBarGraph', am4charts.XYChart);
      chart.preloader.disabled = true;
      const that = this;
      chart.events.on('ready', function (ev) {
        that.isLoading = false;
      });
      var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.dataFields.category = 'key';
      categoryAxis.renderer.minGridDistance = 10;
      categoryAxis.renderer.inversed = true;
      categoryAxis.renderer.grid.template.disabled = true;
      categoryAxis.renderer.line.strokeOpacity = 1;
      categoryAxis.renderer.line.strokeWidth = 1.5;
      var label = categoryAxis.renderer.labels.template;
      label.truncate = true;
      label.maxWidth = 200;
      label.tooltipText = '{category}';
      label.tooltipX = am4core.percent(200);
      var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
      valueAxis.min = 0;
      valueAxis.max = 100;
      valueAxis.strictMinMax = true;
      valueAxis.renderer.grid.template.disabled = true;
      valueAxis.renderer.line.strokeOpacity = 1;
      valueAxis.renderer.line.strokeWidth = 1.5;
      var series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.categoryY = 'key';
      series.dataFields.valueX = 'participation_rate';
      series.tooltipText = '{valueX.value}';
      series.columns.template.strokeOpacity = 0;
      series.columns.template.column.cornerRadiusBottomRight = 5;
      series.columns.template.column.cornerRadiusTopRight = 5;
      series.columns.template.propertyFields.fill = 'color';
      series.columns.template.propertyFields.stroke = 'color';
      // var labelBullet = series.bullets.push(new am4charts.LabelBullet());
      // labelBullet.label.horizontalCenter = 'left';
      // labelBullet.label.dx = 6;
      // labelBullet.label.fill = am4core.color('#fff');
      // labelBullet.label.text = '{valueX}';
      // labelBullet.locationX = 1;
      categoryAxis.sortBySeries = series;
      chart.data = this.barData;
      series.columns.template.width = am4core.percent(50);
      chart.scrollbarY = new am4core.Scrollbar();
      // Pre-zoom the chart
      if (this.barData && this.barData.length > 10) {
        chart.events.on('ready', function () {
          categoryAxis.zoomToIndexes(0, 10);
        });
      }
    },
    handelClickOnRateBar (e) {
      const filters = {
        [this.sortByKey]: []
      };
      filters[this.sortByKey].push(e.item.category);
      const employeeFilters = {
        filters
      };
      this.$store.dispatch('updateEmployeeFilters', employeeFilters);
      this.$router.push({ path: '/employees' });
    }
  }
};
</script>

<style lang="scss" scoped>
#rateBarGraph {
  height: 28rem;
}
</style>
